import { PaneResizer } from '../../components/shared/PaneResizer';

interface CalendarResizerProps {
  /**
   * 어느 패널의 경계인가.
   *  - 'side' : 좌측 사이드바의 오른쪽 경계 → 오른쪽으로 끌수록 넓어진다.
   *  - 'rail' : 우측 선택일 레일의 왼쪽 경계 → 왼쪽으로 끌수록 넓어진다.
   */
  edge: 'side' | 'rail';
  /** 현재 폭(px) — 드래그 시작 기준값이자 aria-valuenow. */
  width: number;
  min: number;
  max: number;
  /** 더블클릭 시 복귀할 기본 폭(px). */
  defaultWidth: number;
  /** 접근성 라벨(스크린리더 + title 툴팁). */
  label: string;
  /** 새 폭 요청 — clamp/영속화는 store 가 담당한다. */
  onResize: (width: number) => void;
}

/**
 * CalendarResizer (calendar-shell-resize — 2026-07-24) — 캘린더 3열 셸의 세로 구분선 핸들.
 *
 * 2026-07-24 메모 패널 작업에서 동작이 공용 `PaneResizer` 로 승격됐다(design-20260724 §4.5).
 * 본 컴포넌트는 캘린더 전용 어휘(edge='side'|'rail')와 CSS 클래스(`cal-resizer`)를 유지하는
 * 얇은 어댑터다 — DOM·클래스·접근성 속성은 승격 전과 동일하므로 CalendarShell.css 무수정.
 */
export function CalendarResizer({ edge, width, min, max, defaultWidth, label, onResize }: CalendarResizerProps) {
  return (
    <PaneResizer
      anchor={edge === 'side' ? 'left' : 'right'}
      width={width}
      min={min}
      max={max}
      defaultWidth={defaultWidth}
      label={label}
      onResize={onResize}
      baseClass="cal-resizer"
      variant={edge}
    />
  );
}
